---
type: post
authors:
  - alex-patterson
cloudinary_convert: false
cover: https://media.codingcat.dev/image/upload/v1616546840/main-codingcatdev-photo/hmhr4khpcbyynnmisr5y.jpg
devto: https://dev.to/codingcatdev/angular-pwa-to-google-play-store-using-trusted-web-activity-5en4
excerpt: Add your PWA to Google Play Store today!
hashnode: https://hashnode.codingcat.dev/tutorial-angular-pwa-to-google-play-store-using-trusted-web-activity
preview: https://codingcat.dev/api/preview?secret=7tjQhb1qQlS3FtyV3b0I&selectionType=tutorial&selectionSlug=angular-pwa-to-google-play-store-using-trusted-web-activity&_id=c9c11b5cfd37469791c90454c4d2e472
published: archived
slug: angular-pwa-to-google-play-store-using-trusted-web-activity
start: May 22, 2022
title: Angular PWA to Google Play store, using Trusted Web Activity
youtube: https://youtu.be/db9Y5jyparA
---

> PWA’s are still changing rapidly. This tutorial may not be as up to date, so I have removed the content and left the video for history
